import React from 'react';
import { BookOpenIcon, TargetIcon } from 'lucide-react';
import { tomos } from '../data/content';
import { CTAButton } from './CTAButton';
export function Tomos() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-16" data-id="element-254" data-mp="1h32rqefkvgth">
      <div className="mx-auto max-w-3xl" data-id="element-255" data-mp="1h4ducaxaeij0">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-256" data-mp="1cbugdcuotldo">
          📦 Qué encontrarás dentro
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-257" data-mp="1qzfip4jqngkj">
          Ruta Clínica GLP-1™
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-700/80" data-id="element-258" data-mp="2028b5b4npyby">
          No es otro PDF para guardar en tu computadora. Es un sistema práctico
          que organiza cada decisión clínica que debes tomar cuando un paciente
          inicia tratamiento con GLP-1.
        </p>
        <p className="mx-auto mt-4 max-w-xl rounded-xl bg-brand-light px-4 py-3 text-center text-[14px] font-semibold leading-snug text-navy-800" data-id="element-259" data-mp="1ndorxzktyji">
          📘 Seis Tomos Clínicos que te acompañan desde la primera consulta
          hasta el seguimiento a largo plazo.
        </p>

        <div className="mt-8 space-y-4" data-id="element-260" data-mp="3eoe4n8q6zb8n">
          {tomos.map(tomo => <article key={tomo.number} className="rounded-2xl border border-navy-100 bg-cream p-5 shadow-card" data-id="element-261" data-mp="3jfmbbx050ii4">
              <p className="inline-flex items-center gap-1.5 rounded-full bg-navy-900 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white" data-id="element-262" data-mp="3oe5xnyin7wb0">
                <BookOpenIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-263" data-mp="19hsg01rt5wa" />
                {tomo.number}
              </p>
              <h3 className="mt-3 font-serif text-[21px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-264" data-mp="681a3o9bzviu">
                {tomo.title}
              </h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-navy-900/80" data-id="element-265" data-mp="280fv4w769g3h">
                {tomo.description}
              </p>
              <p className="mt-3 flex gap-2 rounded-xl border border-teal/25 bg-white p-3 text-[13.5px] font-semibold leading-snug text-navy-900" data-id="element-266" data-mp="200t0or8fwklx">
                <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-267" data-mp="1w0iupekndu72" />
                <span data-id="element-268" data-mp="24ykzm57i56zm">
                  <span className="text-teal" data-id="element-269" data-mp="24x9otlfn2yz0">Resultado: </span>
                  {tomo.result}
                </span>
              </p>
            </article>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-270" data-mp="2evz9tn2u0zjh">
          <CTAButton label="Quiero los 6 Tomos Clínicos" note="6 Tomos + 5 Bonos por USD $15" data-id="element-271" data-mp="2ev7k2svx1w14" />
        </div>
      </div>
    </section>;
}